import React from "react";
import HeaderWithSearch from "./HeaderWithSearch";
import ImageWithFallback from "./ImageWithFallback";

function NewYear() {
  return (
    <>
      <HeaderWithSearch />
      <main style={{
        minHeight: "100vh",
        width: "100%",
        background: "linear-gradient(180deg, #e3f0fc 0%, #fafdff 100%)",
        padding: 0,
        margin: 0
      }}>
        <section style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "60vh",
          padding: "60px 0 40px 0"
        }}>
          <h1 style={{ fontSize: "3rem", fontWeight: "bold", marginBottom: 12 }}>New Year Drawing</h1>
          <p style={{ fontSize: "1.3rem", color: "#333", marginBottom: 32 }}>A festive drawing for the New Year.</p>
          <ImageWithFallback src="/new_year_2023.png" alt="New Year Drawing" style={{ width: 340, borderRadius: 24, boxShadow: "0 4px 32px rgba(0,0,0,0.10)", marginBottom: 24 }} />
          <div style={{ fontSize: "1.1rem", color: "#555", maxWidth: 600, textAlign: "center" }}>
            Celebrate the New Year with this creative drawing project!
          </div>
        </section>
      </main>
    </>
  );
}

export default NewYear;
